export default {"src":"/_next/static/media/Zen HR.7de27546.svg","height":312,"width":312,"blurWidth":0,"blurHeight":0};